import script from "./VideoCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCapture.vue?vue&type=script&setup=true&lang=js"

import "./VideoCapture.vue?vue&type=style&index=0&id=00b104e4&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b104e4"]])

export default __exports__